import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography
} from '@mui/material';

export default function ModaleRicalcoloIndicatori({ open, onClose, onConfirm }) {
  const [selectedFornitore, setSelectedFornitore] = useState('');

  const handleConfirm = () => {
    if (!selectedFornitore) return;
    onConfirm(selectedFornitore); // lo passa al padre
    setSelectedFornitore('');
  };

  const handleClose = () => {
    setSelectedFornitore('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          color: 'red',
          fontSize: '1.5rem',
          fontWeight: 'bold',
        }}
      >Attenzione</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Questa azione è irreversibile. Prima di procedere, seleziona il
          fornitore dei dati:
        </Typography>
        <RadioGroup
          value={selectedFornitore}
          onChange={(e) => setSelectedFornitore(e.target.value)}
        >
          <FormControlLabel value="S" control={<Radio />} label="SevenData" />
          <FormControlLabel value="C" control={<Radio />} label="CreditSafe" />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annulla</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!selectedFornitore}
        >
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
}